import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ThankYou.css';
import { CheckCircle, House, ShoppingCart, Phone } from 'phosphor-react';

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="thank-you-container">
      <div className="thank-you-content">
        <div className="thank-you-icon">
          <CheckCircle size={80} weight="fill" />
        </div>
        
        <h1>Obrigado pelo seu pedido!</h1>
        <p className="thank-you-message">
          Recebemos o seu pedido de orçamento e a nossa equipa irá analisá-lo.
          <br />
          Entraremos em contacto consigo nas próximas 24-48 horas.
        </p>

        <div className="next-steps">
          <h2>Próximos Passos</h2>
          <div className="steps-grid">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Análise do Pedido</h3>
                <p>A nossa equipa técnica irá analisar o seu pedido e as suas necessidades específicas.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Contacto</h3>
                <p>Entraremos em contacto consigo para esclarecer detalhes e agendar uma visita técnica, se necessário.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Proposta</h3>
                <p>Apresentaremos uma proposta detalhada com preços, prazos e condições de instalação.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Instalação</h3>
                <p>Após aprovação, agendaremos a instalação conforme a sua disponibilidade.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-info">
          <h3>Precisa de falar connosco?</h3>
          <div className="contact-details">
            <div className="contact-item">
              <Phone size={24} />
              <div>
                <strong>Telefone</strong>
                <p>+351 256 418 202</p>
              </div>
            </div>
            <div className="contact-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <div>
                <strong>Morada</strong>
                <p>Rua da Empresa, 123<br />4000-000 Porto</p>
              </div>
            </div>
            <div className="contact-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <div>
                <strong>Email</strong>
                <p>mlptelecomunicacoes@gmail.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/')}
          >
            <House size={20} />
            Voltar ao Início
          </button>
          <button 
            className="btn btn-secondary"
            onClick={() => navigate('/')}
          >
            <ShoppingCart size={20} />
            Continuar Compras
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
